module.exports = __webpack_public_path__ + "static/carlcox-469e798c7b03a4aee649083029f911f1.jpg";